export var AttackType;
(function (AttackType) {
    AttackType[AttackType["Melee"] = 1] = "Melee";
    AttackType[AttackType["Ranged"] = 2] = "Ranged";
})(AttackType || (AttackType = {}));
export const ATTACK_TYPE_MELEE = 1;
export const ATTACK_TYPE_RANGED = 2;
